import React, { useEffect } from "react";
import ContentHeader from "../../components/Layout/Content/ContentHeader/ContentHeader";
import { UIText } from "../../enums/UIText/UIText";
import LayoutContentWrapper from "../../components/Layout/LayoutContentWrapper/LayoutContentWrapper";
import { useAppSelector } from "../../hooks/redux";
import { getLanguage } from "../../store/selectors/appSelector";
import styles from "./Cookies.module.css";

import { getTextByLanguage } from "../../enums/utils/getTextByLanguage";
import { EnumLanguage } from "../../enums/EnumLanguage";
import { EnumPages } from "../../enums/EnumPages";

const Cookies = () => {
	const language = useAppSelector(getLanguage);

	useEffect(() => {
		document.title = `${UIText.nav.cookies[language]} - ${UIText.mis[EnumLanguage.ru]}`;
	}, [language]);

	function getText() {
		switch (language) {
			case EnumLanguage.ru:
				return (
					<>
						<p>
							Когда вы посещаете этот сайт, Федеральное государственное бюджетное учреждение культуры «Всероссийское музейное
							объединение «Государственная Третьяковская галерея» может использовать общеотраслевую технологию, называемую
							cookie. Файлы cookie представляют собой небольшие фрагменты данных, которые временно сохраняются на вашем
							компьютере или мобильном устройстве и обеспечивают более эффективную работу сайта.
						</p>
						<p>
							Федеральное государственное бюджетное учреждение культуры «Всероссийское музейное объединение «Государственная
							Третьяковская галерея» для сбора статистики использует подсистему «Цифровая культура». На основе этих данных мы
							делаем наш сайт лучше и эффективнее для пользователей.
						</p>
						<p>
							Продолжая пользоваться этим сайтом, вы соглашаетесь на использование cookie и обработку данных в соответствии с{" "}
							<a href='/cookies'>
								<b>Политикой конфиденциальности</b>
							</a>{" "}
							в области обработки и защиты персональных данных.
						</p>
						<p>
							Если вы не хотите использовать cookie, вы можете отключить их в настройках безопасности вашего браузера.
							Отключение cookie следует выполнить для каждого браузера и устройства, с помощью которого осуществляется вход на
							сайт.
						</p>
						<p>
							Обратите внимание, что в случае, если использование сайтом cookie-файлов отключено, некоторые возможности и
							услуги сайта могут быть недоступны. Согласие на обработку персональных данных посетителей сайта Настоящим,
							свободно, своей волей и в своем интересе выражаю свое согласие юридический адрес: Адрес: 119017, г. Москва,
							Лаврушинский пер., д. 10 (далее – Оператор) на автоматизированную обработку моих персональных данных в
							соответствии со следующим перечнем персональных данных:
							<ul>
								<li>Мои запросы как посетителя сайта.</li>
								<li>Системная информация, данные из моего браузера.</li>
								<li>Файлы cookie.</li>
								<li>Мой IP-адрес.</li>
								<li>Установленные на моем устройстве операционные системы.</li>
								<li>Установленные на моем устройстве типы браузеров.</li>
								<li>Установленные на моем устройстве расширения и настройки цвета экрана.</li>
								<li>Установленные и используемые на моем устройстве языки.</li>
								<li>Версии Flash и поддержка JavaScript.</li>
								<li>Типы мобильных устройств, используемых мной, если применимо.</li>
								<li>Географическое положение.</li>
								<li>Количество посещений сайта и просмотров страниц.</li>
								<li>Длительность пребывания на сайте.</li>
								<li>Запросы, использованные мной при переходе на сайт.</li>
								<li>Страницы, с которых были совершены переходы.</li>
							</ul>
						</p>
						<p>
							Для целей сбора статистики о посетителях сайта Оператор вправе осуществлять обработку моих персональных данных
							следующими способами: сбор, систематизация, накопление, хранение, обновление, изменение, использование. Оператор
							может обрабатывать файлы cookie самостоятельно или с привлечением иных сервисов.
						</p>{" "}
						<p>
							Настоящее согласие вступает в силу с момента моего перехода на сайт Оператора и действует до момента его отзыва.
						</p>{" "}
						<p>Согласие действует на период: 1 год.</p>{" "}
						<p>
							Согласие на обработку персональных данных может быть отозвано мною путем письменного уведомления по указанному
							адресу об этом не менее чем за один месяц до даты фактического прекращения обработки моих персональных данных
							Оператором.
						</p>
					</>
				);
			case EnumLanguage.en:
				return (
					<>
						<p>
							When you visit this website, the Federal State Budgetary Institution of Culture "All-Russian Museum Association
							"State Tretyakov Gallery" may use a cross-industry technology called cookies. Cookies are small pieces of data
							that are temporarily stored on your computer or mobile device and help the website to function more efficiently.
						</p>
						<p>
							The Federal State Budgetary Institution of Culture "All-Russian Museum Association"State Tretyakov Gallery" uses
							the "Digital Culture" subsystem for collecting statistics. Based on this data, we make our website better and
							more efficient for users.
						</p>
						<p>
							By continuing to use this site, you agree to the use of cookies and the processing of data in accordance with
							the{" "}
							<a href='/cookies'>
								<b>Privacy Policy</b>
							</a>{" "}
							in the field of personal data processing and protection.
						</p>
						<p>
							If you do not want to use cookies, you can disable them in your browser's security settings. Disabling cookies
							should be done for each browser and device used to access the site.
						</p>
						<p>
							Please note that if the use of cookie files by the site is disabled, some features and services of the site may
							be unavailable. Consent to the processing of personal data of site visitors Hereby, freely, of my own will and
							in my interest, I express my consent Legal address: Address: 119017, Moscow, Lavrushinsky Lane, 10 (hereinafter
							referred to as the Operator) to the automated processing of my personal data in accordance with the following
							list of personal data:
							<ul>
								<li>My requests as a site visitor.</li>
								<li>System information, data from my browser.</li>
								<li>Cookie files.</li>
								<li>My IP address.</li>
								<li>Operating systems installed on my device.</li>
								<li>Types of browsers installed on my device.</li>
								<li>Extensions installed on my device and screen color settings.</li>
								<li>Languages installed and used on my device.</li>
								<li>Flash versions and JavaScript support.</li>
								<li>Types of mobile devices used by me, if applicable.</li>
								<li>Geographical location.</li>
								<li>Number of site visits and page views.</li>
								<li>Duration of stay on the site.</li>
								<li>Requests used by me when navigating to the site.</li>
								<li>Pages from which transitions were made.</li>
							</ul>
						</p>
						<p>
							For the purpose of collecting statistics about site visitors, the Operator has the right to process my personal
							data by the following methods: collection, systematization, accumulation, storage, updating, modification, and
							use. The Operator may process cookie files independently or with the involvement of other services.
						</p>
						<p>
							This consent comes into force from the moment of my access to the Operator's website and is valid until its
							withdrawal.
						</p>
						<p>The consent is valid for a period of: 1 year.</p>
						<p>
							Consent to the processing of personal data can be revoked by me by written notification to the specified address
							no later than one month before the actual date of termination of the processing of my personal data by the
							Operator.
						</p>
					</>
				);
			case EnumLanguage.cn:
				return (
					<>
						<p>
							当您访问本网站时，“俄罗斯联邦国家文化预算制度机构”全俄博物馆联合体“国家特雷托夫画廊”可能会使用一种称为cookie的跨行业技术。
							Cookie是暂时存储在您的计算机或移动设备上的小数据片段，有助于网站更高效地运行。
						</p>
						<p>
							“俄罗斯联邦国家文化预算制度机构”全俄博物馆联合体“国家特雷托夫画廊”使用“数字文化”子系统进行统计数据收集。基于这些数据，我们使我们的网站对用户更好、更高效。
						</p>
						<p>
							继续使用本网站，即表示您同意使用cookie并按照隐私政策在个人数据处理和保护领域处理数据。
							<a href='/cookies'>
								<b>隐私政策</b>
							</a>
						</p>
						<p>如果您不想使用cookie，可以在浏览器的安全设置中禁用它们。禁用cookie应针对访问该网站的每个浏览器和设备执行。</p>
						<p>
							请注意，如果禁用站点的cookie文件，则可能会导致站点的某些功能和服务无法使用。我自由、自愿并在我自己的利益下同意该操作符号对站点访问者个人数据的自动处理。法定地址：地址：119017，莫斯科，拉夫鲁申斯基巷，10号（以下简称为操作者）按照以下个人数据清单自动处理我的个人数据：
							<ul>
								<li>作为网站访问者的我的请求。</li>
								<li>系统信息，来自我的浏览器的数据。</li>
								<li>Cookie文件。</li>
								<li>我的IP地址。</li>
								<li>我设备上安装的操作系统。</li>
								<li>我设备上安装的浏览器类型。</li>
								<li>我设备上安装的扩展和屏幕颜色设置。</li>
								<li>我设备上安装和使用的语言。</li>
								<li>Flash版本和JavaScript支持。</li>
								<li>我使用的移动设备类型，如果适用。</li>
								<li>地理位置。</li>
								<li>网站访问量和页面浏览量。</li>
								<li>停留时间。</li>
								<li>我在导航到网站时使用的请求。</li>
								<li>进行转换的页面。</li>
							</ul>
						</p>
						<p>
							为了收集有关网站访问者的统计数据，操作者有权通过以下方式处理我的个人数据：收集、系统化、积累、存储、更新、修改和使用。操作者可以独立或利用其他服务处理cookie文件。
						</p>
						<p>该同意自我访问操作者网站之时生效，并有效直至撤销。</p>
						<p>该同意有效期为：1年。</p>
						<p>我可以通过书面通知指定地址在操作者实际停止处理我的个人数据之前一个月内撤销对个人数据处理的同意。</p>
					</>
				);

			default:
				break;
		}
	}

	return (
		<>
			<div className={styles.pageWrapper}>
				<LayoutContentWrapper>
					<ContentHeader title={getTextByLanguage(UIText.nav.cookies, language)} pageName={EnumPages.cookies} />
					{getText()}
				</LayoutContentWrapper>
			</div>
		</>
	);
};

export default Cookies;
